import React, {  useState, useEffect} from 'react'
import {Link} from 'react-router-dom'
import { useParams } from 'react-router-dom';
import { addConversationStart, fetchConversationsByServiceStart, fetchCustomerConversationsStart } from './../redux/Conversations/conversations.actions';
import { useDispatch, useSelector } from 'react-redux';
import Button from './../components/forms/Button'
import DashAuthWrapper from './../components/DashAuthWrapper'

const mapState = ({ user, conversationsData }) => ({
	currentUser: user.currentUser,
	conversations: conversationsData.conversations,
	
})

const ConversationDetails = props => {
	const { currentUser, conversations } = useSelector(mapState);
	const { vendorID, productName } = useParams();
	const dispatch = useDispatch();
	const [convoDesc, setConvoDesc] = useState('');
	const [serviceName, setServiceName] = useState(productName);
	const [custName, setCustName] = useState(currentUser.displayName);
	const [custPhone, setCustPhone] = useState(currentUser.phone);
	const [custEmail, setCustEmail] = useState(currentUser.email);
	const [custsID, setCustID] = useState(currentUser.id);
	const [vendorsID, setVendorID] = useState(vendorID);
	const [userRoles, setUserRoles] = useState(currentUser.userRoles[0]);
	const [userID, setUserID] = useState(currentUser.id);

	const { data2 } = conversations;

	  useEffect(() => {
		window.scrollTo(0, 0)
		dispatch(
			fetchConversationsByServiceStart(productName)
		);
		dispatch(
			fetchCustomerConversationsStart()
		);
		// eslint-disable-next-line
	}, []);


	const resetForm = () => {
		setConvoDesc('');
		setServiceName(productName);
		setCustName(currentUser.displayName);
		setCustPhone(currentUser.phone);
		setCustEmail(currentUser.email);
		setCustID(currentUser.id);
		setVendorID(vendorID);
		setUserRoles(currentUser.userRoles[0]);
		setUserID(currentUser.id);
	};

	const handleSubmit = e => {
		e.preventDefault();
	
		dispatch(
			addConversationStart({
				convoDesc,
				serviceName,
				custName,
				custPhone,
				custEmail,
				custsID,
				vendorsID,
				userRoles,
				userID
			  })
		);
		resetForm();
	
	};

	//create and filter conversation array
	const convoByService = [];
	if(Array.isArray(data2)){
		for(let i = 0; i < data2.length; i++){
			if(data2[i].custsID === `${currentUser.id}` &&data2[i].vendorsID === `${vendorID}` && data2[i].serviceName === `${productName}`){
				convoByService.push(data2[i]);
			}
		}
	}
	
	// console.log(convoByService)
	const congfigAuthWrapper = {
		headline: `${productName} Chat`
	}

	return (
		<div>
			{!currentUser.subscribed &&(
				<DashAuthWrapper>
					<h3 className="mt-5">You currently have no subscription</h3>
				
					<h3>Please 
						<Link to="/services">
							<Button>
								SUBSCRIBE
							</Button>
						</Link>
						to be eligible for services
					</h3>
				</DashAuthWrapper>
			)}

			{currentUser.subscribed &&(
				<DashAuthWrapper {...congfigAuthWrapper}>

					<div className="mt-5 chat">
						{(Array.isArray(convoByService) && convoByService.length > 0) && convoByService.map((product, index) => {
							const {
								convoDesc,
								serviceName,
								userRoles

							} = product;
									
						return (
							
							
							<div className="row" index={index}>
								{userRoles === 'vendor' &&(
									<div className="vendorConvo">
										<div className="px-3 font-italic text-muted">
											{serviceName} 
										</div>
										{/* <div className="px-3">
											{custName} 
										</div> */}
										<div className="px-3">
											{convoDesc} 
										</div>
									</div>
								)}

								{userRoles === 'customer' &&(
									<div className="custConvo">
										{/* <div className="px-3">
											{serviceName} 
										</div>
										<div className="px-3">
											{custName} 
										</div> */}
										<div className="px-3">
											{convoDesc} 
										</div>
									</div>
								)}

							</div>
							
							)
						})}

					</div>
					


					<div className="convo-body mt-5">
					<form onSubmit={handleSubmit}>
						

						<textarea value={convoDesc} rows="4" cols="50" placeholder="Enter text here..." onChange={e => setConvoDesc(e.target.value)}></textarea>
            			<br />


						<Button type="submit">
							Submit
						</Button>
					</form>
					</div>

					
				</DashAuthWrapper>
			)}
		</div>	




		
	)
}

export default ConversationDetails;